<template lang="pug">
  b-form-row.variant-value-row
    b-col(md="4")
      b-form-group
        div.mb-2
          span.font-weight-bold Variante
          span.ml-2.text-secondary (Por ejemplo: Talla)
          b-spinner.ml-3(small variant="primary" v-if="loading")
        b-form-input(v-model="variant.name", placeholder="Nombre de variante", @input="updateVariant" :disabled="loading")
    b-col(md="8")
      b-form-group
        b-row.alignt-items-center.mb-2
          b-col
            span.font-weight-bold Valores
            span.ml-2.text-secondary (Por ejemplo: Chico, Mediano, Grande)
          b-col(cols="auto")
            b-form-checkbox(switch, size="sm" v-model="variant.enabled", @change="updateVariant" :disabled="loading") {{variant.enabled ? 'Activado' : 'Desactivado'}}
          b-col(cols="auto")
            trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="confirmDeleteVariant")
        b-form-tags(:value="variant_values" :disabled="loading", @input="updateValues", tag-variant="primary", placeholder="", add-button-text="Agregar", duplicate-tag-text="Valores duplicados", separator=",")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import _debounce from "lodash.debounce";
export default {
  data () {
    return {
      loading: false,
    }
  },
  props: {
    variant: {
      default: function () {
        return {}
      }
    }
  },
  computed: {
    variant_values () {
      return this.variant.Variant_Values.map(v => {
        return v.value
      })
    }
  },
  methods: {
    ...mapActions([
      "variant/update",
      "variant/destroy",
      "variant/assign_value",
      "variant/update_value",
      "variant/remove_value",
      "product_variant/combination_variants",
    ]),
    updateVariant: _debounce(function () {
      if(!this.variant.name.length) {
        this.$message.warning('El nombre no puede ir vacío')
        return
      }
      let self = this
      this.loading = true

      this['variant/update']({
        ...this.variant,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Variante actualizada')
          }
        }
      })
    }, 700, {leading: false, trailing: true}),
    confirmDeleteVariant () {
      let self = this

      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar la variante ${this.variant.name}? No se puede deshacer.`, {
        title: 'Eliminar variante',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      })
          .then(value => {
            if (value == true) {
              self.destroyVariant()
            }
          })
          .catch(err => {
            // An error occurred
            console.error(err)
          })
    },
    destroyVariant () {
      let self = this
      this.loading = true

      this['variant/destroy']({
        variant_id: this.variant.variant_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Variante eliminada')
            self.getCombinations()
            console.log(res)
            if(res.resource.combinations && res.resource.combinations.length) {
              res.resource.combinations.forEach(r => {
                self.$store.commit('product_variant/removeItem', r)
              })
            }
          }
        }
      })
    },
    createVariantValue (value) {
      let self = this
      this.loading = true

      this['variant/assign_value']({
        variant_id: this.variant.variant_id,
        value: value,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            this.variant.Variant_Values.push(res.resource)
            self.$message.success('Valor agregado')
            self.getCombinations()
          }
        }
      })
    },
    updateVariantValue: _debounce(function (variant_value) {
      if(!variant_value.value.length) {
        this.$message.warning('El valor no puede ir vacío')
        return
      }
      let self = this
      variant_value.loading = true

      this['variant/update_value']({
        ...variant_value,
        callback: res => {
          variant_value.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Valor actualizado')
          }
        }
      })
    }, 700, {leading:false, trailing: true}),
    confirmDeleteVariantValue(variant_value, index) {
      let self = this
      this.$bvModal.msgBoxConfirm(`¿Deseas eliminar el valor ${variant_value.value}? No se puede deshacer.`, {
        title: 'Eliminar valor',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      })
          .then(value => {
            if (value == true) {
              self.destroyVariantValue(variant_value, index)
            }
          })
          .catch(err => {
            // An error occurred
            console.error(err)
          })
    },
    destroyVariantValue (value) {
      let index = this.variant.Variant_Values.findIndex(v => v.value == value)
      if(index < 0) return
      let self = this
      this.loading = true

      this['variant/remove_value']({
        ...this.variant.Variant_Values[index],
        callback: res => {
          this.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Valor eliminado')
            self.variant.Variant_Values.splice(index, 1)
            self.getCombinations()
            if(res.resource.combinations && res.resource.combinations.length) {
              res.resource.combinations.forEach(r => {
                self.$store.commit('product_variant/removeItem', r)
              })
            }
          }
        }
      })
    },
    updateValues (values) {
      let added = this.getDiference(values, this.variant_values)
      let removed = this.getDiference(this.variant_values, values)
      if(added.length >= 1)
        this.createVariantValue(added[0])
      if(removed.length >= 1)
        this.destroyVariantValue(removed[0])
    },
    getDiference (big, small) {
      return big.filter(function(b) {
        return !small.some(function(s) {
          return b == s;
        });
      });
    },
    getCombinations () {
      let self = this
      this.loading = true

      this['product_variant/combination_variants']({
        product_id: self.$route.params.product_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            // self.$message.error(res.error)
          }
        }
      })
    },
  },
  mounted () {

  },
}
</script>

<style lang="scss" scoped>
  .variant-value-row:not(:last-child) {
    margin-bottom: 3rem;
  }
</style>
